import React, { Component } from "react";
import { connect } from "react-redux";
import { shape, arrayOf, string, bool } from "prop-types";
import Col from "react-bootstrap/lib/Col";
import Container from "pages/_components/Container";
import Heading from "pages/_components/Heading";
import { compose } from "redux";
import { selectors as sessionSelectors } from "reducers/session";
import { accountDescription } from "util/checks";
import { selectors as debinSelectors } from "reducers/debin";
import classNames from "classnames";

const FORM_ID = "debin.recurrency";

class RecurrencySummaryData extends Component {
    static propTypes = {
        debinPrestacion: shape({}).isRequired,
        accounts: arrayOf(
            shape({
                idProduct: string.isRequired,
            }),
        ).isRequired,
        isDesktop: bool.isRequired,
    };

    createAccountDescription = () => {
        const { debinPrestacion, accounts } = this.props;

        const account = accounts.find((a) => a.idProduct === debinPrestacion?.account);

        const { productAlias, number, currency, productType } = account;

        return accountDescription(productAlias, number, currency, productType);
    };

    render() {
        const { debinPrestacion, isDesktop } = this.props;
        return (
            <>
                <Container
                    className="flex-grow align-items-center container-white with-margin with-padding-1-rem mb-1"
                    gridClassName="form-content">
                    <Col xs={12} md={3} className="px-0">
                        <Heading.DataGroup
                            containerClassName={classNames(
                                "data-wrapper-flex",
                                { "transfer-data data-wrapper-flex-column": isDesktop },
                                { "transaction-ticket-detail space-between m-0": !isDesktop },
                            )}
                            labelClassName="data-label-medium mr-2"
                            dataClassName="data-desc"
                            label={`${FORM_ID}.account.title`}
                            data={this.createAccountDescription()}
                        />
                    </Col>
                    <Col xs={12} md={3} className="px-0">
                        <Heading.DataGroup
                            containerClassName={classNames(
                                "data-wrapper-flex",
                                { "transfer-data data-wrapper-flex-column": isDesktop },
                                { "transaction-ticket-detail space-between m-0": !isDesktop },
                            )}
                            labelClassName="data-label-medium mr-2"
                            dataClassName="data-desc"
                            label={`${FORM_ID}.seller.name.title`}
                            data={debinPrestacion?.seller?.titular}
                        />
                    </Col>
                    <Col xs={12} md={3} className="px-0">
                        <Heading.DataGroup
                            containerClassName={classNames(
                                "data-wrapper-flex",
                                { "transfer-data data-wrapper-flex-column": isDesktop },
                                { "transaction-ticket-detail space-between m-0": !isDesktop },
                            )}
                            labelClassName="data-label-medium mr-2"
                            dataClassName="data-desc"
                            label={`${FORM_ID}.seller.cuit.title`}
                            data={debinPrestacion?.seller?.cuit}
                        />
                    </Col>

                    <Col xs={12} md={3}>
                        <></>
                    </Col>
                </Container>
                <Container
                    className="flex-grow align-items-center container-white with-margin with-padding-1-rem mt-1"
                    gridClassName="form-content">
                    <Col xs={12} md={3} className="px-0">
                        <Heading.DataGroup
                            containerClassName={classNames(
                                "data-wrapper-flex",
                                { "transfer-data data-wrapper-flex-column": isDesktop },
                                { "transaction-ticket-detail space-between m-0": !isDesktop },
                            )}
                            labelClassName="data-label-medium mr-2"
                            dataClassName="data-desc"
                            label={`${FORM_ID}.prestacion.title`}
                            data={debinPrestacion?.prestacionSeleccionada?.nombre}
                        />
                    </Col>
                    <Col xs={12} md={3} className="px-0">
                        <Heading.DataGroup
                            containerClassName={classNames(
                                "data-wrapper-flex",
                                { "transfer-data data-wrapper-flex-column": isDesktop },
                                { "transaction-ticket-detail space-between m-0": !isDesktop },
                            )}
                            labelClassName="data-label-medium mr-2"
                            dataClassName="data-desc"
                            label={`${FORM_ID}.reference.title`}
                            data={debinPrestacion?.prestacionSeleccionada?.ayuda_referencia}
                        />
                    </Col>
                    <Col xs={12} md={3} className="px-0">
                        <Heading.DataGroup
                            containerClassName={classNames(
                                "data-wrapper-flex",
                                { "transfer-data data-wrapper-flex-column": isDesktop },
                                { "transaction-ticket-detail space-between m-0": !isDesktop },
                            )}
                            labelClassName="data-label-medium mr-2"
                            dataClassName="data-desc"
                            label={`${FORM_ID}.concept.title`}
                            data={debinPrestacion?.concept}
                        />
                    </Col>
                    <Col xs={12} md={3} className="px-0">
                        <Heading.DataGroup
                            containerClassName={classNames(
                                "data-wrapper-flex",
                                { "transfer-data data-wrapper-flex-column": isDesktop },
                                { "transaction-ticket-detail space-between m-0": !isDesktop },
                            )}
                            labelClassName="data-label-medium mr-2"
                            dataClassName="data-desc"
                            label={`${FORM_ID}.descripcion.title`}
                            data={debinPrestacion?.description}
                        />
                    </Col>

                    <Col xs={12} md={3}>
                        <></>
                    </Col>
                </Container>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    userId: sessionSelectors.getUser(state).userId,
    accounts: debinSelectors.getAccounts(state),
});

export default compose(connect(mapStateToProps))(RecurrencySummaryData);
